export const offersFR = {
    shippingTitle : "LIVRAISON GRATUITE",
    shippingText1 : "Pour les commandes de plus de ",
    shippingText2 : " €, la livraison est gratuite !",
    cashTitle : "PAIEMENT À LA LIVRAISON",
    cashText : "Paiement à la livraison sans frais supplémentaires !",
    topSellers : "Meilleures ventes" 
}